import React from 'react';
import TableBodyRow from "./TableBodyRow";

function TableBody({data}) {
    return (
        <tbody className="sl-bg-white sl-border sl-rounded-bottom-lg sl-border-solid sl-border-gray-200">
        {data.map((rowData, index) => (
            <TableBodyRow key={index} rowData={rowData}/>
        ))}
        </tbody>
    );
}

export default TableBody;
